var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isActive),expression:"isActive"}],staticClass:"tab-item"},[_vm._t("default",null,{"isActiveTab":_vm.isActive})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }